import React, { Fragment } from 'react';

import { normalizeStringToBooleanValue } from '@utils/normalize/normalizeStringToBooleanValue';


const RadioCheckBoxes = props => {

    const handleValueChange = e => {
        const { dataset: { value } } = e.target;
        const { inputActions = {} } = props;
        const invokeChange = inputActions.handleFieldChange || inputActions.onFieldChange;
        if (invokeChange) {
            invokeChange(!normalizeStringToBooleanValue(value));
        }
    };

    const handleLabelClick = e => {
        e.preventDefault();
        handleValueChange(e);
    };

    const {
        inputData: {
            checked,
            id,
            classes,
            isInputRequired,
            name,
            type,
            nameRadioCheckbox
        },
        label: {
            text,
            labelClass
        },
        legend: {
            legendText,
        } = {}
    } = props;

    const legendDataTestId = `${id}_legend`;

    const inputElement = (
        <input
            id={id}
            data-testid={`${id}_input`}
            name={nameRadioCheckbox ? nameRadioCheckbox : name}
            className={`usa-radio__input gi-${type}__input ${classes && classes.join(' ')} required-${isInputRequired}`}
            type="radio"
            checked={checked}
            onChange={handleValueChange}
            value={checked}
            data-value={checked}
        />
    );

    const labelElement = (
        <label
            data-testid={`${id}_label`}
            htmlFor={id}
            className={`usa-radio__label gi-${type}__label`}
            data-value={checked}
            onClick={handleLabelClick}
        >
            {text}
        </label>
    );

    if (legendText) {
        return (
            <fieldset className={`gi-component gi-${type}`}>
                <legend className={`${labelClass && labelClass.join(' ')} required-${isInputRequired}`} data-testid={legendDataTestId}>
                    {legendText}
                </legend>
                {inputElement}
                {labelElement}
            </fieldset>
        );
    }

    return (
        <Fragment>
            {inputElement}
            {labelElement}
        </Fragment>
    );
};

export default RadioCheckBoxes;
